import { Unit } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

export type GoalReportSwing = {
    createdAt: string;
    parameterValue: number;
    swingUuid: string;
    activityId: number;
};

export type GoalReport = {
    innerMin: number;
    innerMax: number;
    unit: Unit;
    parameterName: string;
    swings?: GoalReportSwing[] | null;
};

export type LayoutGoalReportParams = {
    layoutId: number;
    from?: string;
    to?: string;
    lastSwings?: number;
};

export type LayoutGoalReportResponse = {
    data: Array<{
        innerMin: number;
        innerMax: number;
        unit: string | null;
        parameterName: string;
        parameterId: number;
        swings: GoalReportSwing[];
    }>;
};

export const getLayoutGoalReport = async ({
    layoutId,
    from,
    to,
    lastSwings,
}: LayoutGoalReportParams): Promise<GoalReport[]> => {
    const { data: response } = await apiClient.get<LayoutGoalReportResponse>(
        ApiConfig.path(`/api/v1/layouts/${layoutId}/report`),
        {
            params: {
                from_date: from,
                to_date: to,
                last_n: lastSwings,
            },
        },
    );
    const goalReport = response?.data;
    if (!goalReport?.length) {
        throw Error(`No goal report to generate for goal report with id ${layoutId}`);
    }

    return goalReport.map((goalReport) => ({
        ...goalReport,
        unit: goalReport.unit as Unit,
    }));
};
